import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import { ModeProvider } from './context/ModeContext';
import { MusicProvider } from './context/MusicContext'; 

import Home from './pages/Home';
import Art from './pages/Art';
import Navbar from './components/Navbar/Navbar';
import CommandPalette from './components/CommandPalette/CommandPalette';
import MusicPlayer from './components/MusicPlayer/MusicPlayer'; 
import Footer from './components/Footer/Footer'; // 1. RE-IMPORT FOOTER

const App = () => {
  return (
    <MusicProvider> 
      <Router>
        <ModeProvider> 
          
          <Navbar />
          <CommandPalette />
          <MusicPlayer /> 
          
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/art" element={<Art />} />
          </Routes>
          
          <Footer /> 
          
        </ModeProvider>
      </Router>
    </MusicProvider>
  );
};

export default App;